import { useCallback } from 'react';
import { useAuth } from '@/shared/auth/AuthContext';

/**
 * Ce que le compte courant a le droit de FAIRE, tel que le serveur le dit.
 *
 * POURQUOI CE FICHIER EXISTE
 *
 * La meme regle d'autorisation vivait a trois endroits : `ROLE_CAPABILITIES` cote
 * serveur, la liste `CRM = ['admin', 'commercial']` du routeur, et le drapeau
 * `adminOnly` de la barre laterale. Trois copies derivent, et elles derivent dans le
 * sens rassurant : le menu proposait « Facturation » a un role dont le serveur, lui,
 * savait deja quoi faire. Le journal nginx de la pre-production garde la trace du
 * clic, le 26/08 a 09:47 puis 09:48, sur une entree qui ne repondrait jamais.
 *
 * Le correctif ne synchronise pas les trois copies, il en supprime deux. `/api/auth/me`
 * publie desormais `capacites`, LU dans `backend/app/core/authz.py`. Ajouter une
 * capacite a un role la-bas la fait apparaitre dans le menu ici, sans qu'une ligne de
 * React change.
 *
 * ⚠️ CE N'EST PAS UNE PROTECTION. Le refus reste pose sur le chemin de chaque requete :
 * masquer une entree n'a jamais ferme une route. Ce hook decide de ce qu'on PROPOSE,
 * jamais de ce qu'on PEUT.
 *
 * PENDANT LE CHARGEMENT, on ne propose RIEN de reserve. C'est l'inverse du choix de
 * `useModules`, et pour une raison : un module non souscrit est une question
 * commerciale, une capacite absente est un refus. Montrer une demi-seconde une entree
 * qui va disparaitre vaut mieux que la proposer a qui n'y a pas droit -- ici, l'entree
 * apparait quand la reponse arrive, elle ne clignote pas dans l'autre sens.
 */
export default function useCapacites() {
  const { user } = useAuth();
  const liste = user?.capacites;

  /** `possede(undefined)` vaut vrai : une entree sans capacite exigee est ouverte. */
  const possede = useCallback(
    (capacite) => !capacite || (Array.isArray(liste) && liste.includes(capacite)),
    [liste],
  );

  return { capacites: liste || [], possede, pret: Array.isArray(liste) };
}
